import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import bindActionCreators from '../../../../lib/utils/bindActionCreators'
import getAccessToken from '../../../../lib/utils/getAccessToken'

import NativeDropdown from '../../../../lib/components/NativeDropdown'

import { lobAction } from '../../../../actions'
import { lobSelector } from '../../../../selectors'

import { setFilter } from '../actions'
import { getFilter } from '../selectors'

const { getLOB } = lobAction
const { getListLOB } = lobSelector

/**
 * @typedef {object} Props
 * @property {Array} lobs
 * @property {{ lob: string }} filter
 * @property {typeof getLOB} getLOB
 * @property {typeof setFilter} setFilter
 */

/** @extends {Component<Props>} */
export class LOBFilter extends Component {
  /** @type {Props} */
  static defaultProps = {
    lobs: [],
    filter: {},
    getLOB: () => {},
    setFilter: () => {},
  }

  componentDidMount = async () => {
    const { getLOB } = this.props
    await getLOB(getAccessToken())
  }

  /**
   * @param {string} value
   */
  handleFilterChange = value => {
    const { setFilter } = this.props
    setFilter('lob', value)
  }

  render = () => {
    const { lobs, filter } = this.props
    const options = [{ label: 'Select LOB', value: '' }].concat(
      lobs.map(data => ({ label: data.name, value: data.name }))
    )

    return (
      <NativeDropdown value={ filter.lob } options={ options } onChange={ this.handleFilterChange } />
    )
  }
}

const mapStateToProps = createStructuredSelector({
  lobs: getListLOB,
  filter: getFilter,
})

const mapDispatchToProps = bindActionCreators({
  getLOB,
  setFilter,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LOBFilter)



// WEBPACK FOOTER //
// ./src/pages/report/billing-plan/components/LOBFilter.jsx